import { Loader2 } from 'lucide-react'

/**
 * Inline page loader — used inside MainLayout while a lazy route chunk loads.
 * Keeps the shell (sidebar + header) mounted unlike the full-viewport PageLoader.
 */
export function PageContentLoader() {
  return (
    <div className="flex items-center justify-center py-24" aria-label="Loading page…">
      <Loader2
        className="animate-spin"
        size={28}
        strokeWidth={1.75}
        style={{ color: 'var(--ac-secondary)' }}
        aria-hidden="true"
      />
    </div>
  )
}
